// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentWishListsStyles } from "@guestsupply/App/Widgets/myAccount/NavWishLists";
import { color, mergeWithCss } from "@guestsupply/XDL/Utilities";
import { StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

recentWishListsStyles.gridContainer = {
    gap: 10,
};
recentWishListsStyles.spinnerGridItem = {
    width: 12,
    css: css`
        justify-content: center;
        align-items: center;
    `,
};
recentWishListsStyles.wishListCardGridItem = {
    width: 12,
    css: css`
        ${StyledTypography} {
            color: ${color("text.main")};
            font-size: 13px;
            line-height: 16px;
        }
    `,
};
recentWishListsStyles.loadMoreGridItem = {
    width: 12,
    css: css`
        padding-top: 15px;
    `,
};
recentWishListsStyles.loadMoreLink = {
    typographyProps: {
        size: 14,
        weight: 900,
        css: css`
            letter-spacing: 0;
            line-height: 24px;
        `,
    },
};
recentWishListsStyles.notify = {
    ...mergeWithCss(dataTableStyles.noResultsText, {
        css: css`
            min-width: unset;
            width: 100%;
        `,
    }),
};
